/* eslint-disable prettier/prettier */
export const endpoint = {
  // BASE_URL_STAGING: window.location.origin,
  BASE_URL_STAGING: window.location.host === "localhost:3001" ? "http://localhost:4001": window.location.origin,
  // BASE_URL_STAGING: "https://devlms.iflhousingfinance.in",

  // Authentication / Authorization
  SIGN_IN: "core/public/v1/user/login",
  USER_DETAIL: "core/v1/admin/user/detail",
  LOGOUT: "/auth/v1/oauth/user/logout",
  RETAIN_TOKEN: "auth/v1/oauth2/user/retain-token/",
  APP_URL: "/app/url-link",
  FEATURE_FLAG: "/app/feature-flag",
  LOGO_URL :"core/v1/link/logo-url",
  //Core Module
  ADMIN_USER_AGENTS: "core/v1/admin/user/agents",
  ADMIN_FINDBYSTATUS: "core/v1/admin/loan/application/findByStatus",
  CUSTOMER_APPLICATIONFINDID: "core/v1/customer/loan/application/find?id=",
  ADMIN_APPLICANTIONASSIGN: "core/v1/admin/loan/application/assign",
  BRANCH_FINDALL: "core/v1/admin/branch/findAll",
  ADMIN_BRANCH_REMOVE: "core/v1/admin/branch/remove",
  ADMIN_GOLDRATE_FINDALL: "core/v1/admin/goldrate/findAll",
  ADMIN_GOLDRATE_FINDPURITY: "core/v1/admin/goldrate/find?purity=22k",
  ADMIN_GOLDRATEFIND: "core/v1/admin/goldrate/find?purity=",
  ADMIN_GOLDRATE_REFERSH: "core/v1/admin/goldrate/populateThirdPartyGoldRate",
  ADMIN_GOLDRATE_UPDATE: "core/v1/admin/goldrate/update",
  ADMIN_PINCODE_FINDALLWITHBRANCH: "core/v1/admin/pincode/findAllWithBranch",
  ADMIN_BRANCH: "core/v1/admin/branch/findByCode?code=",
  ADMIN_FINDPINCODES: "core/v1/admin/pincode/findPincodes",
  ADMIN_BRANCHUPDATE: "core/v1/admin/branch/update",
  ADMIN_BRANCH_ADD: "core/v1/admin/branch/add",
  ADMIN_BRANCHADDBULK: "core/v1/admin/branch/addBulk",
  ADMIN_LINKBRANCHPINCODE: "core/v1/admin/branch/linkBranchPincode",
  ADMIN_PINCODEDELINK: "core/v1/admin/pincode/delink",
  ADMIN_FINDBYCODES: "core/v1/admin/branch/findByCode?code=",
  ADMIN_FIND_PINCODES: "core/v1/admin/pincode/findPincodes",
  ADMIN_LOAN_SCHEME_STATUS_UPDATE: "core/v1/loan/scheme/update/status",
  ADMIN_USER_FINDALL: "core/v1/admin/user/findAll",
  ADMIN_USER_DELETE: "core/v1/admin/user/delete?id=",
  ADMIN_USER_ADDBULK: "core/v1/admin/user/addBulk",
  ADMIN_USER_FINDID: "core/v1/admin/user/find?id=",
  ADMIN_USER_ADD: "core/v1/admin/user/add",
  ADMIN_USER_INVITE: "core/v1/admin/user/invite",
  ADMIN_USER_UPDATE: "core/v1/admin/user/update",
  ADMIN_SCHEME_CHANNEL_ALL: "core/v1/loan/scheme-channel/findAll",
  ADMIN_LOANSCHEME_FINDALL: "core/v1/loan/scheme/findAll",
  ADMIN_LOANSCHEME_DELETE: "core/v1/loan/scheme/delete/",
  ADMIN_LOANSCHEME_CREATEBULK: "core/v1/loan/scheme/createBulk",
  ADMIN_LOANSCHEME_FIND: "core/v1/loan/scheme/find/",
  ADMIN_LOANSCHEME_CREATE: "core/v1/loan/scheme/create",
  ADMIN_LOANSCHEME_UPDATE: "core/v1/loan/scheme/update",
  ADMIN_LOANSCHEME_CALCULATELTV: "core/v1/loan/scheme/calculateLtv",
  ADMIN_GOLDRATE_FINDHISTORY: "core/v1/admin/goldrate/findHistory",
  ADMIN_SCHEME_CHARGE_CREATE: "core/v1/loan/scheme/charge/create",
  ADMIN_SCHEME_CHARGE_UPDATE: "core/v1/loan/scheme/charge/update",
  ADMIN_SCHEME_CHARGE_DELETE: "core/v1/loan/scheme/charge/delete/",
  ADMIN_FIND_ALL_CHARGES:"core/v1/chargetype/findAll",
  FIND_ALL_PRODUCT_TYPE:"core/v1/product/findAll",
  // Pincode
  MASTER_PINCODE_FIND: "core/v1/master/pincode/findAll",
  MASTER_PINCODE_ADDBULK: "core/v1/master/pincode/addBulk",
  MASTER_PINCODE_DELETE: "core/v1/master/pincode/remove",
  MASTER_PINCODE_DELINK: "core//v1/pincode-branch/mapping/delinkBranchPincode",
  MASTER_PINCODE_MAPPED_UNMAPPED: "core/v1/master/pincode/find-mapped-unmapped",
  MASTER_PINCODE_FIND_BY_HIERARCHY_CODE: "core/v1/pincode-branch/mapping/find-by-hierarchyCode/", //{hierarchyCode}

  // Zonal Master
  MASTER_ZONES_FINDALL: "core/master/zonal/findAll",
  MASTER_ZONES_FIND_BY_CODE: "core/master/zonal/find/",
  MASTER_ZONES_FIND_BY_NAME: "core/master/zonal/find-by-name/",
  MASTER_ZONES_FIND_BY_STATE: "core/master/zonal/find-by-state/",
  MASTER_ZONES_ADD: "core/master/zonal/add",
  MASTER_ZONES_UPDATE: "core/master/zonal/update",
  MASTER_ZONES_DELETE: "core/master/zonal/delete/",

  // State Master
  MASTER_STATE_FINDALL: "core/master/state/findAll",
  MASTER_STATE_FIND_BY_CODE: "core/master/state/find/",
  MASTER_STATE_FIND_BY_NAME: "core/master/state/find-by-name/",
  MASTER_STATE_UPDATE: "core/master/state/update",

  // Territory Master
  MASTER_TERRITORY_FINDALL: "core/master/territory/findAll",
  MASTER_TERRITORY_FIND_BY_CODE: "core/master/territory/find/",
  MASTER_TERRITORY_FIND_BY_NAME: "core/master/territory/find-by-name/",
  MASTER_TERRITORY_FIND_BY_STATE: "core/master/territory/find-by-state/",
  MASTER_TERRITORY_FIND_BY_REGION:
    "core/master/territory/find-by-regional-code/",
  MASTER_TERRITORY_ADD: "core/master/territory/add",
  MASTER_TERRITORY_UPDATE: "core/master/territory/update",
  MASTER_TERRITORY_DELETE: "core/master/territory/delete/",

  // Regional Master
  MASTER_REGIONAL_FINDALL: "core/master/regional/findAll",
  MASTER_REGIONAL_FIND_BY_CODE: "core/master/regional/find/",
  MASTER_REGIONAL_FIND_BY_NAME: "core/master/regional/find-by-name/",
  MASTER_REGIONAL_FIND_BY_STATE: "core/master/regional/find-by-state/",
  MASTER_REGIONAL_FIND_BY_ZONE: "core/master/regional/find-by-zonal-code/",
  MASTER_REGIONAL_ADD: "core/master/regional/add",
  MASTER_REGIONAL_UPDATE: "core/master/regional/update",
  MASTER_REGIONAL_DELETE: "core/master/regional/delete/",

  // AREA Master
  MASTER_AREA_FINDALL: "core/master/area/findAll",
  MASTER_AREA_FIND_BY_CODE: "core/master/area/find/",
  MASTER_AREA_FIND_BY_NAME: "core/master/area/find-by-name/",
  MASTER_AREA_FIND_BY_STATE: "core/master/area/find-by-state/",
  MASTER_AREA_FIND_BY_TERRITORY: "core/master/area/find-by-area-code/",
  MASTER_AREA_ADD: "core/master/area/add",
  MASTER_AREA_UPDATE: "core/master/area/update",
  MASTER_AREA_DELETE: "core/master/area/delete/",

  // Structure TYPE MASTER
  MASTER_STRUCTURE_TYPE_FINDALL: "core/master/type/findAll",
  MASTER_STRUCTURE_TYPE_FIND: "core/master/type/find/",
  MASTER_STRUCTURE_TYPE_FIND_BY_NAME: "core/master/type/find-by-name/",
  MASTER_STRUCTURE_TYPE_ADD: "core/master/type/add",
  MASTER_STRUCTURE_TYPE_UPDATE: "core/master/type/update",
  MASTER_STRUCTURE_TYPE_DELETE: "core/master/type/delete/",
  MASTER_STRUCUTRE_PARNET_CODE_FIND : "core/master/type/find-available",

  // HIERARCHY MASTER
  MASTER_HIERARCHY_FINDALL: "core/master/hierarchy/findAll",
  MASTER_HIERARCHY_FIND_BY_CODE: "core/master/hierarchy/find/",
  MASTER_HIERARCHY_FIND_BY_NAME: "core/master/hierarchy/find-by-name/",
  MASTER_HIERARCHY_FIND_BY_PARENT_CODE: "core/master/hierarchy/parent-code/find/",
  MASTER_HIERARCHY_FIND_BY_TYPE_CODE: "core/master/hierarchy/master-type-code/find/",
  MASTER_HIERARCHY_FIND_BY_STATE: "core/master/hierarchy/find-by-state/",
  MASTER_HIERARCHY_FIND_BY_TERRITORY: "core/master/hierarchy/find-by-hierarchy-code/",
  MASTER_HIERARCHY_ADD: "core/master/hierarchy/add",
  MASTER_HIERARCHY_UPDATE: "core/master/hierarchy/update",
  MASTER_HIERARCHY_DELETE: "core/master/hierarchy/delete/",
  MASTER_HIERARCHY_PINCODE_DELINK: "core/v1/pincode-branch/mapping/delinkBranchPincode",
  MASTER_HIERARCHY_PINCODE_LINK: "core/v1/pincode-branch/mapping/linkBranchPincode",
  MASTER_HIERARCHY_STATUS_UPDATE: "core/master/hierarchy/update/status",

  // ROLE Master
  MASTER_ROLE_FIND: "core/master/role/find",
  MASTER_ROLE_ADD: "core/master/role/add",
  MASTER_ROLE_UPDATE: "core/master/role/update",
  MASTER_ROLE_DELETE: "core/master/role/delete/",
  
  // Sanction Authority
  SANCTION_AUTHORITY_CREATE: "core/v1/sanction-authority/create",
  SANCTION_AUTHORITY_UPDATE: "core/v1/sanction-authority/update",
  SANCTION_AUTHORITY_FIND_LEVEL: "core/v1/sanction-authority/find-level/",
  SANCTION_AUTHORITY_FIND_ALL: "core/v1/sanction-authority/findAll",

  //Ornament Master
  ORNAMENT_CREATE: "core/v1/ornament/master/create",
  ORNAMENT_FINDALL: "core/v1/ornament/master/findAll",
  ORNAMENT_UPDATE: "core/v1/ornament/master/update/",
  ORNAMET_GETDATA:"core/v1/ornament/master/find/",
  ORNAMENT_STATUS_UPDATE: "core/v1/ornament/master/patch/",

  //StandardDeduction
  DEDUCTION_CREATE: "core/v1/standard/deduction/master/create",
  DEDUCTION_FINDALL: "core/v1/standard/deduction/master/findAll",
  DEDUCTION_UPDATE: "core/v1/standard/deduction/master/update/",
  DEDUCTION_GETDATA:"core/v1/standard/deduction/master/find/",
  DEDUCTION_STATUS_UPDATE: "core/v1/standard/deduction/master/patch/",

  //NoticeBoard
  NOTICE_BOARD_CREATE: "core/v1/notice-board/master/create",
  NOTICE_BOARD_FINDALL:"core/v1/notice-board/master/findAll",
  NOTICE_BOARD_UPDATE:"core/v1/notice-board/master/update/",
  NOTICE_BOARD_GET_BY_ID: "core/v1/notice-board/master/find/",
  NOTICE_BOARD_DELETE: "core/v1/notice-board/master/delete/",

    //REGISTERMASTER
    REGISTER_MASTER_CREATE: "core/v1/register/master/create",
    REGISTER_MASTER_FINDALL:"core/v1/register/master/findAll",
    REGISTER_MASTER_UPDATE:"core/v1/register/master/update/",
    REGISTER_MASTER_GET_BY_ID: "core/v1/register/master/find/",
    REGISTER_MASTER_DELETE: "core/v1/register/master/delete/",
  //PACKET INVENTORY

  //PACKET ALLOCATION
  PACKET_ALLOCATION_CREATE:"core/v1/allocated-packet-inventory/create",
  PACKET_ALLOCATION_FINDALL:"core/v1/allocated-packet-inventory/findAll",
  PACKET_ALLOCATION_DELETE:"core/v1/allocated-packet-inventory/delete/",
  PACKET_ALLOCATION_FIND_BY_ID:"core/v1/allocated-packet-inventory/find/",
  PACKET_ALLOCATION_UPDATE:"core/v1/allocated-packet-inventory/update/",

  //PACKET INVENTORY MASTER
  PACKET_INVENTORY_MASTER_CREATE:"core/v1/packet-inventory-master/create",
  PACKET_INVENTORY_MASTER_FINDALL:"core/v1/packet-inventory-master/findAll",
  PACKET_INVENTORY_MASTER_DELETE:"core/v1/packet-inventory-master/delete/",
  PACKET_INVENTORY_MASTER_FIND_BY_ID:"core/v1/packet-inventory-master/find/",
  PACKET_INVENTORY_MASTER_UPDATE:"core/v1/packet-inventory-master/update/",

  //PACKET DAMAGE
  PACKET_DAMAGE_FINDALL: "core/v1/defected-packet-inventory/findAll",
  PACKET_DAMAGE_CREATE: "core/v1/defected-packet-inventory/create",
  PACKET_DAMAGE_UPDATE: "core/v1/defected-packet-inventory/update/",
  PACKET_DAMAGE_DELETE: "core/v1/defected-packet-inventory/delete/",
  PACKET_DAMAGE_FIND_BY_ID: "core/v1/defected-packet-inventory/find/",
  PACKETS_SERIAL_NUMBER:"core/v1/allocated-packet-inventory/find-available/",
  //Lender
  LENDER_FINDALL: "core/v1/lender-master/find-all",
  LENDER_CREATE: "core/v1/lender-master/create",
  LENDER_UPDATE: "core/v1/lender-master/update/",
  LENDER_DELETE: "core/v1/lender-master/delete/",
  LENDER_FIND_BY_ID: "core/v1/lender-master/find/",

  // PACKET HISTORY
  PACKET_SEARCH: "core/v1/packet-inventory-master/search?packetNumber=",

  //BlackList PinCodes
  // Pincode
  MASTER_BLACK_LIST_PINCODE_FIND: "core/v1/blacklisted-pincode/findAll",
  MASTER_BLACK_LIST_PINCODE_ADD_BULK: "core/v1/blacklisted-pincode/addBulk",
  MASTER_BLACK_LIST_PINCODE_DELETE: "core/v1/blacklisted-pincode/remove",
  MASTER_BLACK_LIST_PINCODE_FIND_BY_ID: "core/v1/blacklisted-pincode/findById/",
  MASTER_BLACK_LIST_PINCODE_FIND_BY_PINCODE: "core/v1/blacklisted-pincode/is-blacklisted?",

  //weightage Controller
  MASTER_WEIGHTAGE_CONTROLLER_CREATE: "core/v1/rule-engine/weightage/create",
  MASTER_WEIGHTAGE_CONTROLLER_FIND: "core/v1/rule-engine/weightage/findAll",
  MASTER_WEIGHTAGE_CONTROLLER_FIND_BY_ID: "core/v1/rule-engine/weightage/find/",//{ID}
  MASTER_WEIGHTAGE_CONTROLLER_FIND_BY_PARAM: "core/v1/rule-engine/weightage/find-by-param/",//{param}
  MASTER_WEIGHTAGE_CONTROLLER_UPDATE: "core/v1/rule-engine/weightage/update/",//{ID}
  MASTER_WEIGHTAGE_CONTROLLER_DELETE: "core/v1/rule-engine/weightage/delete/",//{ID}

  //weightage score Controller
  MASTER_WEIGHTAGE_SCORE_CONTROLLER_CREATE: "core/v1/rule-engine/score/create",
  MASTER_WEIGHTAGE_SCORE_CONTROLLER_FIND: "core/v1/rule-engine/score/findAll",
  MASTER_WEIGHTAGE_SCORE_CONTROLLER_FIND_BY_ID: "core/v1/rule-engine/score/findById/",//{ID}
  MASTER_WEIGHTAGE_SCORE_CONTROLLER_FIND_BY_PARAM: "core/v1/rule-engine/score/find-by-rule-param/",//{ruleParam}
  MASTER_WEIGHTAGE_SCORE_CONTROLLER_UPDATE: "core/v1/rule-engine/score/update/",//{ID}
  MASTER_WEIGHTAGE_SCORE_CONTROLLER_DELETE: "core/v1/rule-engine/score/delete/",//{ID}

  //weightage score eligibility Controller
  MASTER_WEIGHTAGE_SCORE_ELIGIBILITY_CONTROLLER_CREATE: "core/v1/rule-engine/eligibility/create",
  MASTER_WEIGHTAGE_SCORE_ELIGIBILITY_CONTROLLER_FIND: "core/v1/rule-engine/eligibility/findAll",
  MASTER_WEIGHTAGE_SCORE_ELIGIBILITY_CONTROLLER_FIND_BY_ID: "core/v1/rule-engine/eligibility/findById/",//{ID}
  MASTER_WEIGHTAGE_SCORE_ELIGIBILITY_CONTROLLER_UPDATE: "core/v1/rule-engine/eligibility/update/",//{ID}
  MASTER_WEIGHTAGE_SCORE_ELIGIBILITY_CONTROLLER_DELETE: "core/v1/rule-engine/eligibility/delete/",//{ID}

  //RelationShip Master
  RELATIONSHIP_MASTER_CREATE: "core/v1/relationship-master/create",
  RELATIONSHIP_MASTER_FINDALL: "core/v1/relationship-master/findAll",
  RELATIONSHIP_MASTER_FINDBYID: "core/v1/relationship-master/find/",
  RELATIONSHIP_MASTER_DELETE: "core/v1/relationship-master/delete/",
  RELATIONSHIP_MASTER_UPDATE: "core/v1/relationship-master/update/",

  //Negative Profile Master
  NEGATIVE_PROFILE_MASTER_CREATE: "core/v1/duediligence/create",
  NEGATIVE_PROFILE_MASTER_FINDALL: "core/v1/duediligence/findAll",
  NEGATIVE_PROFILE_MASTER_FINDBYID: "core/v1/duediligence/find/",
  NEGATIVE_PROFILE_MASTER_DELETE: "core/v1/duediligence/delete/",
  NEGATIVE_PROFILE_MASTER_UPDATE: "core/v1/duediligence/update/",

  //discrepancy-master

  DISCREPANCY_CREATE: "core/v1/discrepancy-master/create",
  DISCREPANCY_FINDALL: "core/v1/discrepancy-master/findAll",
  DISCREPANCY_FINDBYID: "core/v1/discrepancy-master/find/",
  DISCREPANCY_DELETE: "core/v1/discrepancy-master/delete/",
  DISCREPANCY_UPDATE: "core/v1/discrepancy-master/update/",

  // collateral-evaluation-master
  COLLATERAL_EVALUATION_CREATE: "core/v1/sanction/approval/master/create",
  COLLATERAL_EVALUATION_FINDALL: "core/v1/sanction/approval/master/findAll",
  COLLATERAL_EVALUATION_FINDBYID: "core/v1/sanction/approval/master/find",
  COLLATERAL_EVALUATION_DELETE: "core/v1/sanction/approval/master/delete/",
  COLLATERAL_EVALUATION_UPDATE: "core/v1/sanction/approval/master/update/",


  //Risk Category Master
  RISK_CATEGORY_FIND_ALL:"core/v1/loanrisk/categorization/master/findAll",
  RISK_CATEGORY_UPDATE:"core/v1/loanrisk/categorization/master/update/",
  RISK_CATEGORY_CREATE:"core/v1/loanrisk/categorization/master/create",
  RISK_CATEGORY_DELETE:"core/v1/loanrisk/categorization/master/delete/",

  //Risk Category Score Master
  RISK_CATEGORY_SCORE_FIND_ALL:"core/v1/loanrisk/categorization/score/master/findAll",
  RISK_CATEGORY_SCORE_UPDATE:"core/v1/loanrisk/categorization/score/master/update/",
  RISK_CATEGORY_SCORE_CREATE:"core/v1/loanrisk/categorization/score/master/create",
  RISK_CATEGORY_SCORE_DELETE:"core/v1/loanrisk/categorization/score/master/delete/",

  RISK_CATEGORY_AND_SCORE_DATA:"core/v1/loanrisk/categorization/score/master/findCategories",
  RISK_WEIGHTAGE_SCORE_CREATE:"core/v1/loanrisk/categorization/weightage/add",
  RISK_WEIGHTAGE_SCORE_FIND_ALL:"core/v1/loanrisk/categorization/weightage/findAll",
  RISK_WEIGHTAGE_SCORE_DELETE:"core/v1/loanrisk/categorization/weightage/delete/",
  RISK_WEIGHTAGE_SCORE_UPDATED:"core/v1/loanrisk/categorization/weightage/add-bulk",

  INSURED_ELIGIBILITY_CREATE:"core/v1/insurance/eligibility/master/create",
  INSURED_ELIGIBILITY_FINDALL:"core/v1/insurance/eligibility/master/findAll",
  INSURED_ELIGIBILITY_DELETE:"core/v1/insurance/eligibility/master/delete/",

  SUMINSURED_FIND_ALL: "core/v1/insurance/suminsured/master/findAll",
  SUMINSURED_CREATE: "core/v1/insurance/suminsured/master/create",
  SUMINSURED_DELETE: "core/v1/insurance/suminsured/master/delete/",


  THIRD_PARTY_CREATE:"core/v1/thirdparty/integration/master/create",
  THIRD_PARTY_FINDALL:"core/v1/thirdparty/integration/master/findAll",
  THIRD_PARTY_UPDATE:"core/v1/thirdparty/integration/master/update",
  THIRD_PARTY_DELETE:"core/v1/thirdparty/integration/master/delete/",
  THIRD_PARTY_VENDORS_FIND:"core/v1/thirdparty/integration/master/find/vendors/",

  HOLIDAY_MASTER_CREATE:'/core/v1/master/holiday/create',
  HOLIDAY_MASTER_FINDALL:'core/v1/master/holiday/findAll',

  GET_FIXED_LENDING_RATE:"/core/v1/admin/goldrate/findIbja/",
  FIND_ALL_BRANCH:"core/v1/branch/find",

  GL_HEAD_CREATE_BULK:"core/v1/gl/ledger/create-bulk",
  GL_HEAD_FIND:"core/v1/gl/ledger//find?productType=",
  GL_HEAD_UPDATE_BY_ID:"core/v1/gl/ledger/update/",
  GET_PRODUCT_TYPE:"core/v1/product/findAll",

  //IP WhiteList Master
  CREATE_IP_WHITE_LIST_MASTER:"core/v1/branch/ip/whitelist/create",
  UPDATE_IP_WHITE_LIST_MASTER:"core/v1/branch/ip/whitelist/update/",
  FINDALL_IP_WHITE_LIST_MASTER:"core/v1/branch/ip/whitelist/findAll",
  FIND_BY_BRANCH_IP_WHITE_LIST_MASTER:"core/v1/branch/ip/whitelist/find?branchCodes=",
  FIND_BY_ID_IP_WHITE_LIST_MASTER:"core/v1/branch/ip/whitelist/find/",
  DELETE_BY_ID_IP_WHITE_LIST_MASTER:"core/v1/branch/ip/whitelist/delete/",

  //Restriction MAster
  UI_RESTRICTION_CREATE:"core/v1/ui/restriction/create",
  UI_RESTRICTION_UPDATE:"core/v1/ui/restriction/update/",
  UI_RESTRICTION_FIND:"core/v1/ui/restriction/find?",

  //Partner Master
  PARTNER_CREATE:"core/v1/lending/partner/master/create",
  PARTNER_UPDATE:"core/v1/lending/partner/master/update/",
  PARTNER_DELETE:"core/v1/lending/partner/master/delete/",
  PARTNER_FIND: "core/v1/lending/partner/master/findAll",
  PARTNER_GETDATA:"core/v1/lending/partner/master/find?id=",

  //Partner Master Deal
  PARTNER_DEAL_CREATE:"core/v1/lending/partner/deal/master/create",
  PARTNER_DEAL_UPDATE:"core/v1/lending/partner/deal/master/update/",
  PARTNER_DEAL_DELETE:"core/v1/lending/partner/deal/master/delete/",
  PARTNER_DEAL_FIND: "core/v1/lending/partner/deal/master/findAll",
  PARTNER_DEAL_GETDATA:"core/v1/lending/partner/deal/master/find/",
  PARTNER_DEAL_MASTER_FIND_ID:"core/v1/lending/partner/deal/master/find/",
  PARTNER_DEAL_DEAL_SHARE_FIND_DEAL_CODE:"core/v1/lending/partner/deal/share/master/find-by-code/",
  PARTNER_LENDING_FIND_DEALS:"core/v1/lending/partner/deal/master/find?partnerCode=",

  PARTNER_DEAL_SHARE_CREATE:"core/v1/lending/partner/deal/share/master/create",
  PARTNER_DEAL_SHARE_UPDATE:"core/v1/lending/partner/deal/share/master/update/",
  PARTNER_DEAL_SHARE_DELETE:"core/v1/lending/partner/deal/share/master/delete/",
  PARTNER_DEAL_SHARE_FIND: "core/v1/lending/partner/deal/share/master/findAll",
  PARTNER_DEAL_SHARE_GETDATA:"core/v1/lending/partner/deal/share/master/find/",

  LENDING_DETAIL_FIND:"core/v1/lending/partner/deal/master/find?productType=",

  RENEWAL_TOP_UP_VALIDATION_CREATE:"core/v1/renewal-topup/master/create",
  RENEWAL_TOP_UP_VALIDATION_UPDATE:"core/v1/renewal-topup/master/update/",
  RENEWAL_TOP_UP_VALIDATION_FINDALL:"core/v1/renewal-topup/master/findAll",
  RENEWAL_TOP_UP_VALIDATION_FIND_SUBTYPE:"/core/v1/renewal-topup/master/find/",

  DESIGNATION_FINDALL: "core/v1/master/designation/findAll",
  DESIGNATION_ADD: "core/v1/master/designation/add",
  DESIGNATION_DELETE: "core/v1/master/designation/delete/",
  DESIGNATION_UPDATE: "core/v1/master/designation/update/",

  DEVIATION_CREATE: "core/v1/deviation/master/create",
  DEVIATION_UPDATE: "core/v1/deviation/master/update/",
  DEVIATION_FIND_BY_RULE: "core/v1/deviation/master/find/",
  DEVIATION_DELETE: "core/v1/deviation/master/delete/",
  DEVIATION_FINDALL: "core/v1/deviation/master/findAll",

  LEAD_VALIDATION_CREATE:"core/v1/lead/validation/master/create",
  LEAD_VALIDATION_UPDATE:"core/v1/lead/validation/master/update/",
  LEAD_VALIDATION_FINDALL:"core/v1/lead/validation/master/findAll",
  LEAD_VALIDATION_DELETE:"core/v1/lead/validation/master/delete/",

  NEGATIVE_REGISTERY_ADD:"core/v1/customer/negative/registry/master/add",
  NEGATIVE_REGISTERY_FINDALL:"core/v1/customer/negative/registry/master/findAll",
  NEGATIVE_REGISTERY_UPDATE:"core/v1/customer/negative/registry/master/update/",
  NEGATIVE_REGISTERY_DELETE:"core/v1/customer/negative/registry/master/delete/",

  GL_HEAD_LIST_API:"lms/v1/ledger/find/ledgerName",

  //Master Category 
  MASTER_CATEGORY_CREATE: "core/v1/master/category/create",
  MASTER_CATEGORY_UPDATE: "core/v1/master/category/update/",
  MASTER_CATEGORY_FINDALL: "core/v1/master/category/findAll",
  MASTER_CATEGORY_DELETE: "core/v1/master/category/delete/",
  MASTER_CATEGORY_FIND_BY_ID: "core/v1/master/category/find/",

  //Master category item
  MASTER_CATEGORY_ITEM_CREATE: "core/v1/master/item/create",
  MASTER_CATEGORY_ITEM_UPDATE: "core/v1/master/item/update/",
  MASTER_CATEGORY_ITEM_FINDALL: "core/v1/master/item/findAll",
  MASTER_CATEGORY_ITEM_DELETE: "core/v1/master/item/delete/",
  MASTER_CATEGORY_ITEM_FIND_BY_ID: "core/v1/master/item/find/",

  //Foir config master
  FOIR_CONFIG_CREATE:"core/v1/master/foir-config/create",
  FOIR_CONFIG_FINDALL:"core/v1/master/foir-config/find-all",
  FOIR_CONFIG_FIND_BY_ID:"core/v1/master/foir-config/find/",
  FOIR_CONFIG_DELETE:"core/v1/master/foir-config/delete/",
  FOIR_CONFIG_UPDATE:"core/v1/master/foir-config/update/",

  //Diamond master
  DIAMOND_MASTER_CREATE:"core/v1/diamond/rate/create",
  DIAMOND_MASTER_UPDATE:"core/v1/diamond/rate/update/",
  DIAMOND_MASTER_FIND_ALL:"core/v1/diamond/rate/findAll",
  DIAMOND_MASTER_FIND_ID:"core/v1/diamond/rate/find/",
  DIAMOND_MASTER_RATE_SEARCH:"core/v1/diamond/rate/search",

  //Silver Master
  SILVER_MASTER_FIND_ALL:"core/v1/admin/silver-rate/findAll",
  SILVER_MASTER_FIND_PUTIRY:"core/v1/admin/silver-rate/find?purity=_999",
  SILVER_MASTER_RATE_FIND: "core/v1/admin/silver-rate/find?purity=",
  SILVER_MASTER_UPDATE: "core/v1/admin/silver-rate/update",
  SILVER_MASTERLENDING_RATE:"core/v1/admin/silver-rate/average-market-price",
};
